export function noopReducer<T>(defaults: T) {
  return (state: T | undefined): T => {
    return state || defaults;
  };
}
